import { render, staticRenderFns } from "./Baise.vue?vue&type=template&id=2ed94b4d&scoped=true&"
import script from "./Baise.vue?vue&type=script&lang=js&"
export * from "./Baise.vue?vue&type=script&lang=js&"
import style0 from "./Baise.vue?vue&type=style&index=0&id=2ed94b4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed94b4d",
  null
  
)

export default component.exports